import { Fragment } from 'react';
import { Link, useLocation } from 'react-router';
import { paths } from '@shared/config/paths';
import { breadcrumbsFor } from './breadcrumbs';

/** Fil d'Ariane, affiché uniquement lorsqu'il apporte du contexte. */
export function Breadcrumb() {
  const { pathname } = useLocation();
  const crumbs = breadcrumbsFor(pathname);
  if (crumbs.length === 0) return null;

  return (
    <nav aria-label="Fil d'Ariane">
      <ol className="flex items-center gap-1.5 text-sm">
        <li>
          <Link
            to={paths.dashboard}
            className="text-slate-500 transition-colors hover:text-slate-700"
          >
            Accueil
          </Link>
        </li>
        {crumbs.map((crumb) => (
          <Fragment key={crumb.to ?? crumb.label}>
            <li aria-hidden="true" className="text-slate-300">
              /
            </li>
            <li aria-current={crumb.to ? undefined : 'page'}>
              {crumb.to ? (
                <Link
                  to={crumb.to}
                  className="text-slate-500 transition-colors hover:text-slate-700"
                >
                  {crumb.label}
                </Link>
              ) : (
                <span className="font-medium text-slate-900">{crumb.label}</span>
              )}
            </li>
          </Fragment>
        ))}
      </ol>
    </nav>
  );
}
